import { render } from "./PrintLabelUA.vue?vue&type=template&id=472a9243&scoped=true"
import script from "./PrintLabelUA.vue?vue&type=script&lang=js"
export * from "./PrintLabelUA.vue?vue&type=script&lang=js"

import "./PrintLabelUA.vue?vue&type=style&index=0&id=472a9243&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-472a9243"]])

export default __exports__